<h2>Woordenschat</h2>

<div class="woordenschat">
    <span class="woord">LETS</span>
    <span class="verklaring">LETS Local Exchange Trade System - Lokaal ruilhandelssysteem <br>
        of anders gezegd:   Leuk EigenTijds Samenwerken <br>
        of Lokaal Economisch Transactie Systeem <br>
        of beter nog: <br>
        een netwerk van mensen die iets voor elkaar willen doen.</span>
</div>

<div class="woordenschat">
    <span class="woord">LETSen</span>
    <span class="verklaring">Meedoen met LETS ... wij zien dat dus als een werkwoord ;-) <br>
        Wij kunnen zonder problemen LETSen met alle LETSers uit het grote LETS Aalst-Oudenaarde.</span>
</div>

<div class="woordenschat">
    <span class="woord">LETSer</span>
    <span class="verklaring">
        Iemand die LETSt, dus meedoet met LETS.  
    </span>
</div>

<div class="woordenschat">
    <span class="woord">ietsen</span>
    <span class="verklaring">
        Onze 'munteenheid' in de LETSgroep Aalst-Oudenaarde. <br>
        Wij 'waarderen' (i.p.v. betalen) elkaar met ietsen. (En omdat we eigenlijk de tijd betalen, en tijd voor iedereen gelijk is, is onze 'prijs' voor alle diensten steeds 20 ietsen per uur.)  
    </span>
</div>

<div class="woordenschat">
    <span class="woord">LetsC</span>
    <span class="verklaring">
        Onze beveiligde website waar we vraag/aanbod, nieuws <br>
        en contactgegevens kunnen opzoeken <br>
        en onze eigen gegevens, vraag/aanbod kunnen beheren <br>
        en de 'ietsen' kunnen overschrijven naar wie ze verdiend heeft.   
    </span>
</div>

<div class="woordenschat">
    <span class="woord">infosessie</span>
    <span class="verklaring">
        Wie lid wil worden zou liefst eerst een infosessie volgen, <br>
        zodat je goed weet wat LETS is en hoe onze groep werkt. <br>
        Je leert er ook alles wat je moet weten over LetsC, <br>
        en met een beetje geluk leer je er direct nieuwe LETSers kennen. <br>
        In principe gaat er een infosessie door om de 2 maand.  
    </span>
</div>

<div class="woordenschat">
    <span class="woord">wisselkoers</span>
    <span class="verklaring">
      Om goederen te 'waarderen' moet er soms eens gerekend worden: <br>
1 uur werken = 20 ietsen = 20 euro (maar niet betalen in euro hee). <br>
In LETS verdien je dus veel voor je werk ;-) <br>
Iets doen voor een ander vinden wij heel waardevol.
    </span>
</div>

<div class="woordenschat">
    <span class="woord">km-vergoeding</span>
    <span class="verklaring">Die is bepaald op 25cent/km (Makkelijk om te berekenen (tip-> km : 4) en niet te veel, <br>
        anders wordt het een drempel die het LETSen tegenwerkt.) <br>
        Liefst niet voor korte verplaatsingen, best vooraf goed afspreken. <br>
        Dat zijn echte kosten, en die worden wel betaald in euro &hellip; <br>
        tenzij de ontvanger liever ietsen ontvangt als km-vergoeding ;-)
    </span>
</div>

<div class="woordenschat">
    <span class="woord">LETS Aalst-Oudenaarde</span>
    <span class="verklaring">
        Onze heel grote LETSgroep … met veel LETSers en dus een ruime vraag en aanbod. <br>
(Voor praktische zaken soms onderverdeeld in subgroepen.)
    </span>
</div>

<div class="woordenschat">
    <span class="woord">LETS Regio Zottegem – Vlaamse Ardennen</span>
    <span class="verklaring">Onze subgroep (deel van Lets Aalst-Oudenaarde) <br>
        omvat Zottegem, Brakel, Zwalm, Gavere, Oosterzele, St.-Lievens-Houtem, Herzele en Lierde.</span>
</div>

<div class="woordenschat">
    <span class="woord">subgroepen</span>
    <span class="verklaring">
        Soms is het soms makkelijker dat we de grote groep indelen in subgroepen <br>
        (-> regio Oudenaarde, regio Zottegem, regio Aalst, regio Asse-Ternat) <br>
        maar iedereen is eigenlijk lid van onze groep LETS Aalst-Oudenaarde.   
    </span>
</div>

<div class="woordenschat">
    <span class="woord">interLETSen</span>
    <span class="verklaring">
        Occasioneel is het zelfs tof om met een andere LETSgroep te LETSen. (Bijvoorbeeld omdat je in die regio iemand kent, of daar regelmatig komt, of daar wil gaan logeren?) Dat kan met bv. LETS Merelbeke, LETS Dendermonde en nog tal van andere LETSgroepen.
    </span>
</div>

<style scoped>
.woordenschat {
    display: flex;
}

.woord {
    width: 250px;
}

.verklaring {
    width: 100%;
}
</style>